import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface BarcodeScannerFooterProps {
  onEnterManually: () => void;
}

export const BarcodeScannerFooter = ({ onEnterManually }: BarcodeScannerFooterProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <p className="barcode-scanner__not-your-machine">
      <span>{t('service.identifyDevice.barcodeScanner.notYourMachineQuestion')} </span>
      <Typography.Link className="barcode-scanner__not-your-machine-link" onClick={onEnterManually}>
        {t('service.identifyDevice.barcodeScanner.manualButton')}
      </Typography.Link>
    </p>
  );
};
